import styled from 'styled-components'
import { videoElementAtom } from '../atoms'
import { useEffect, useState } from 'react'
import { Spinner } from '@geist-ui/react'
import useAtomWithRef from '../../../../utils/useAtomWithRef'

/*======================== React component ===================================*/

const LoadingOverlay = (): JSX.Element => {
  const [videoElementRef, videoElement] = useAtomWithRef(videoElementAtom)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (videoElement) {
      // Show the loading spinner when the player is paused and the next segment is loading
      videoElement.addEventListener('waiting', () => {
        const bufferLength = videoElement.buffered.length
        if (bufferLength == 0) return

        // The current time is always less than the end of the buffer with a
        // deviation of < 0.1 seconds.
        if (
          videoElementRef.current!.buffered.end(bufferLength - 1) <
          videoElementRef.current!.currentTime + 0.1
        ) {
          setIsLoading(true)
        }
      })

      videoElement.addEventListener('playing', () => {
        setIsLoading(false)
      })
    }
  }, [videoElement])

  return (
    <Wrapper isVisible={isLoading}>
      <Spinner scale={2} />
    </Wrapper>
  )
}

export default LoadingOverlay

/*======================== Styled components =================================*/

const Wrapper = styled.div<{ isVisible: boolean }>`
  pointer-events: none;
  z-index: 200;
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  display: ${(props) => (props.isVisible ? 'flex' : 'none')};
`
